var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { makeList } from '@or-sdk/base';
import { SdkApi } from '@or-sdk/sdk-api';
export class Accounts {
    constructor(params) {
        const { token, discoveryUrl, sdkUrl } = params;
        this.sdkApi = new SdkApi({
            token,
            discoveryUrl,
            sdkUrl,
        });
    }
    listAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.sdkApi.makeRequest({
                method: 'GET',
                route: '/accounts',
            });
            return makeList(result);
        });
    }
    getAccount(accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sdkApi.makeRequest({
                method: 'GET',
                route: `/accounts/${encodeURIComponent(accountId)}`,
            });
        });
    }
    getAccountData(accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sdkApi.makeRequest({
                method: 'GET',
                route: `/accounts/${encodeURIComponent(accountId)}/account-data`,
            });
        });
    }
    createAccount(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sdkApi.makeRequest({
                method: 'POST',
                route: '/accounts',
                data,
            });
        });
    }
    disableAccount(accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sdkApi.makeRequest({
                method: 'PUT',
                route: `/accounts/${encodeURIComponent(accountId)}/disable`,
            });
        });
    }
    enableAccount(accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sdkApi.makeRequest({
                method: 'PUT',
                route: `/accounts/${encodeURIComponent(accountId)}/enable`,
            });
        });
    }
    updateAccountData(accountId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sdkApi.makeRequest({
                method: 'PUT',
                route: `/accounts/${encodeURIComponent(accountId)}`,
                data,
            });
        });
    }
    scrollSecrets() {
        return __awaiter(this, arguments, void 0, function* ({ accountId = 'current', limit = 10, next, } = {}) {
            const data = yield this.sdkApi.makeRequest({
                method: 'GET',
                route: `/accounts/${encodeURIComponent(accountId)}/keys`,
                params: {
                    maxKeys: limit,
                    next,
                },
            });
            return {
                isTruncated: data.isTruncated,
                next: data.next,
                total: data.count,
                items: data.records,
            };
        });
    }
    getKey(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accountId = 'current', key }) {
            return this.sdkApi.makeRequest({
                method: 'GET',
                route: `/accounts/${encodeURIComponent(accountId)}/keys/${encodeURIComponent(key)}`,
            });
        });
    }
    createKey(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accountId = 'current', key, secret, type, expireTime, meta }) {
            return this.sdkApi.makeRequest({
                method: 'PUT',
                data: {
                    key,
                    data: secret,
                    type,
                    expireTime,
                    meta,
                    mode: 'create',
                },
                route: `/accounts/${encodeURIComponent(accountId)}/keys`,
            });
        });
    }
    updateKey(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accountId = 'current', key, expireTime, meta }) {
            return this.sdkApi.makeRequest({
                method: 'PUT',
                data: {
                    key,
                    expireTime: expireTime,
                    meta: meta,
                    mode: 'update',
                },
                route: `/accounts/${encodeURIComponent(accountId)}/keys`,
            });
        });
    }
    updateKeySecret(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accountId = 'current', key, secret }) {
            return this.sdkApi.makeRequest({
                method: 'PUT',
                data: {
                    key,
                    data: secret,
                    mode: 'updateSecret',
                },
                route: `/accounts/${encodeURIComponent(accountId)}/keys`,
            });
        });
    }
    deleteKey(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accountId = 'current', key }) {
            return this.sdkApi.makeRequest({
                method: 'DELETE',
                data: { key },
                route: `/accounts/${encodeURIComponent(accountId)}/keys`,
            });
        });
    }
}
//# sourceMappingURL=Accounts.js.map